export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-map-1200-95e245dd22f60d9c430ca7a866e02715.webp";